import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Turns arbitrary admin input into a clean, URL-safe slug (lowercase, hyphenated,
// no stray whitespace). Category slugs are hand-typed in the admin form, so without
// this a slug like "Accessories " (trailing space, mixed case) gets saved verbatim
// and silently breaks every exact-string slug match used for routing/filtering.
export function slugify(str = '') {
  return str
    .toString()
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// Case/whitespace-insensitive slug comparison, so categories saved before slugs
// were normalized on write still match correctly instead of silently showing zero
// products.
export function slugsMatch(a, b) {
  if (!a || !b) return false;
  return slugify(a) === slugify(b) || a.trim().toLowerCase() === b.trim().toLowerCase();
}
